var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIOsAppStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Badge_iOS_App_Store",
    "data-name": "Badge \\u2014 iOS App Store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.432,
    height: 37.898,
    viewBox: "0 0 118.432 37.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4596",
    "data-name": "Path 4596",
    d: "M726.024,363h-101.6a14.014,14.014,0,0,0-1.981.19,7.124,7.124,0,0,0-1.881.568,6.024,6.024,0,0,0-1.585,1.137,5.829,5.829,0,0,0-1.188,1.516,6.431,6.431,0,0,0-.594,1.8,13.714,13.714,0,0,0-.2,1.895V393.7a12.359,12.359,0,0,0,.2,1.895,5.564,5.564,0,0,0,.594,1.8A4.977,4.977,0,0,0,618.98,399a6.023,6.023,0,0,0,1.585,1.137,6.169,6.169,0,0,0,1.881.568,14.014,14.014,0,0,0,1.981.189H728a14.014,14.014,0,0,0,1.981-.189,6.182,6.182,0,0,0,1.882-.568A6.033,6.033,0,0,0,733.451,399a5.828,5.828,0,0,0,1.188-1.516,5.563,5.563,0,0,0,.594-1.8,12.246,12.246,0,0,0,.2-1.895V370.106a12.247,12.247,0,0,0-.2-1.895,5.564,5.564,0,0,0-.594-1.8,6.249,6.249,0,0,0-4.654-3.221A14.014,14.014,0,0,0,728,363h-1.98Z",
    transform: "translate(-617 -363)",
    fill: "#a6a6a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4597",
    "data-name": "Path 4597",
    d: "M625.5,400h-.888a12.573,12.573,0,0,1-1.875-.189,11.105,11.105,0,0,1-1.677-.471,7,7,0,0,1-1.381-.943,4.244,4.244,0,0,1-.987-1.32,4.372,4.372,0,0,1-.494-1.6,10,10,0,0,1-.2-1.791V370.22a11.071,11.071,0,0,1,.2-1.791,4.794,4.794,0,0,1,.592-1.507,6.7,6.7,0,0,1,.987-1.32,7.006,7.006,0,0,1,1.381-.943,4.9,4.9,0,0,1,1.677-.471A11.376,11.376,0,0,1,624.71,364H727.925a14.016,14.016,0,0,1,1.875.189,11.1,11.1,0,0,1,1.677.471,5.375,5.375,0,0,1,2.369,2.263,4.531,4.531,0,0,1,.494,1.507,11.078,11.078,0,0,1,.2,1.791v23.468a12.334,12.334,0,0,1-.2,1.791,10.06,10.06,0,0,1-.494,1.6,6.7,6.7,0,0,1-.987,1.32,4.441,4.441,0,0,1-1.381.943,3.442,3.442,0,0,1-1.677.471,11.371,11.371,0,0,1-1.875.189H625.5Z",
    transform: "translate(-617.053 -363.053)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4598",
    "data-name": "Path 4598",
    d: "M641.337,382.318a4.94,4.94,0,0,1,2.266-4.178,4.912,4.912,0,0,0-3.778-2.189c-1.6-.2-3.116.995-3.966.995s-2.078-.995-3.4-.995a5.1,5.1,0,0,0-4.25,2.686c-1.794,3.283-.472,8.257,1.323,10.943.85,1.293,1.888,2.786,3.211,2.786,1.322-.1,1.794-.9,3.4-.9s1.983.9,3.4.9,2.266-1.293,3.116-2.686a9.082,9.082,0,0,0,1.417-3.084A4.436,4.436,0,0,1,641.337,382.318Z",
    transform: "translate(-617.544 -363.679)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4599",
    "data-name": "Path 4599",
    d: "M639.153,373.974a5.06,5.06,0,0,0,1.039-3.482,4.316,4.316,0,0,0-3.022,1.691,4.661,4.661,0,0,0-1.038,3.382A3.74,3.74,0,0,0,639.153,373.974Z",
    transform: "translate(-618.005 -363.394)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4600",
    "data-name": "Path 4600",
    d: "M655.18,387.823h3.588l-1.794-5.471h-.094Zm3.966,1.492h-4.439l-1.038,3.382H651.78l4.25-12.336h1.888l4.249,12.336H660.28Z",
    transform: "translate(-618.828 -363.912)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4601",
    "data-name": "Path 4601",
    d: "M670.079,388.4c0-1.791-.85-2.984-2.266-2.984-1.322,0-2.266,1.194-2.266,2.984s.945,2.984,2.266,2.984C669.229,391.387,670.079,390.194,670.079,388.4Zm1.889,0c0,2.785-1.416,4.576-3.589,4.576a2.724,2.724,0,0,1-2.644-1.592v4.477h-1.794V383.926h1.7v1.492a3.135,3.135,0,0,1,2.738-1.592C670.457,383.727,671.968,385.617,671.968,388.4Z",
    transform: "translate(-619.467 -364.094)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4602",
    "data-name": "Path 4602",
    d: "M680.041,388.4c0-1.791-.85-2.984-2.266-2.984-1.323,0-2.267,1.194-2.267,2.984s.945,2.984,2.267,2.984C679.191,391.387,680.041,390.194,680.041,388.4Zm1.794,0c0,2.785-1.417,4.576-3.589,4.576a2.723,2.723,0,0,1-2.644-1.592v4.477h-1.794V383.926h1.7v1.492a3.137,3.137,0,0,1,2.739-1.592C680.418,383.727,681.836,385.617,681.836,388.4Z",
    transform: "translate(-619.985 -364.094)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4603",
    "data-name": "Path 4603",
    d: "M688.77,389.2c.095,1.194,1.228,1.99,2.833,1.99,1.511,0,2.55-.8,2.55-1.89,0-.995-.66-1.492-2.172-1.89l-1.511-.4c-2.172-.6-3.116-1.592-3.116-3.283,0-2.089,1.794-3.581,4.249-3.581s4.156,1.492,4.25,3.581h-1.795a2.217,2.217,0,0,0-2.456-1.99c-1.416,0-2.361.8-2.361,1.89,0,.9.661,1.393,2.173,1.791l1.322.3c2.361.6,3.4,1.592,3.4,3.382,0,2.288-1.794,3.78-4.534,3.78-2.644,0-4.344-1.393-4.438-3.681Z",
    transform: "translate(-620.687 -363.901)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4604",
    "data-name": "Path 4604",
    d: "M700.259,381.622v2.089h1.606V385.2h-1.606v4.974c0,.8.283,1.094,1.039,1.094h.567v1.492a3.058,3.058,0,0,1-.945.1c-1.7,0-2.361-.7-2.361-2.388V385.3h-1.228v-1.492h1.228v-2.089h1.7Z",
    transform: "translate(-621.221 -363.979)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4605",
    "data-name": "Path 4605",
    d: "M709.539,388.4c0-1.99-.85-3.084-2.266-3.084s-2.266,1.094-2.266,3.084.85,3.084,2.266,3.084S709.539,390.293,709.539,388.4Zm-6.327,0c0-2.785,1.606-4.576,4.061-4.576s4.061,1.791,4.061,4.576c0,2.885-1.6,4.576-4.061,4.576C704.723,392.979,703.212,391.189,703.212,388.4Z",
    transform: "translate(-621.53 -364.094)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4606",
    "data-name": "Path 4606",
    d: "M713.279,383.826h1.7v1.592a1.968,1.968,0,0,1,2.078-1.592,1.144,1.144,0,0,1,.567.1v1.691a2.233,2.233,0,0,0-.755-.1,1.819,1.819,0,0,0-1.794,1.791v5.67h-1.794Z",
    transform: "translate(-622.059 -364.094)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4607",
    "data-name": "Path 4607",
    d: "M720.057,387.5h4.249a2.167,2.167,0,0,0-1.983-2.288h-.19A2.181,2.181,0,0,0,720.057,387.5Zm5.949,2.686a3.518,3.518,0,0,1-3.683,2.785c-2.456,0-4.061-1.791-4.061-4.576s1.511-4.676,3.966-4.676c2.361,0,3.872,1.691,3.872,4.477v.6h-6.044v.1a2.385,2.385,0,0,0,1.983,2.587h.283a1.849,1.849,0,0,0,1.983-1.293Z",
    transform: "translate(-622.321 -364.089)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4608",
    "data-name": "Path 4608",
    d: "M653.69,375.425h1.037a1.811,1.811,0,0,0,1.887-1.761v-.391a1.849,1.849,0,0,0-1.509-2.055H653.69Zm1.132-5.089a2.48,2.48,0,0,1,2.642,2.349v.489c0,1.86-.944,2.936-2.642,2.936h-2.076v-5.871h2.076Z",
    transform: "translate(-618.878 -363.38)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4609",
    "data-name": "Path 4609",
    d: "M661.936,374.039q0-1.468-1.133-1.468c-.755,0-1.132.586-1.132,1.468,0,.978.377,1.565,1.132,1.565S661.936,375.016,661.936,374.039Zm-3.114,0a2,2,0,0,1,1.793-2.251,1.967,1.967,0,0,1,2.171,1.86v.391a2,2,0,0,1-1.794,2.25,1.966,1.966,0,0,1-2.17-1.859Z",
    transform: "translate(-619.197 -363.461)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4610",
    "data-name": "Path 4610",
    d: "M668.426,376.295h-.849l-.849-3.229h-.094l-.849,3.229h-.849l-1.132-4.4h.849l.755,3.327h.094l.849-3.327h.849l.849,3.327h.094l.755-3.327h.849Z",
    transform: "translate(-619.459 -363.467)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4611",
    "data-name": "Path 4611",
    d: "M670.973,371.886h.85v.685h.094a1.357,1.357,0,0,1,1.227-.784,1.4,1.4,0,0,1,1.51,1.37v3.131H673.8v-2.642c0-.685-.283-1.076-.945-1.076a.984.984,0,0,0-1.037.978v2.74h-.85Z",
    transform: "translate(-619.836 -363.461)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594",
    "data-name": "Rectangle 1594",
    width: 0.849,
    height: 6.165,
    transform: "translate(56.044 6.663)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4612",
    "data-name": "Path 4612",
    d: "M681.453,374.039q0-1.468-1.132-1.468c-.755,0-1.132.586-1.132,1.468,0,.978.377,1.565,1.132,1.565C680.981,375.6,681.453,375.016,681.453,374.039Zm-3.208,0a2,2,0,0,1,1.793-2.251,1.967,1.967,0,0,1,2.171,1.86v.391a2,2,0,0,1-1.793,2.25,1.966,1.966,0,0,1-2.171-1.859Z",
    transform: "translate(-620.218 -363.461)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4613",
    "data-name": "Path 4613",
    d: "M686.156,374.626v-.391l-1.038.1c-.567,0-.849.293-.849.586,0,.391.377.587.754.587.567.2,1.038-.2,1.133-.881Zm-2.737.391c0-.783.567-1.271,1.6-1.271l1.133-.1v-.392c0-.489-.283-.684-.85-.684a.794.794,0,0,0-.849.489h-.85a1.53,1.53,0,0,1,1.7-1.272,1.5,1.5,0,0,1,1.7,1.468v3.034h-.849V375.7h-.095a1.412,1.412,0,0,1-1.321.685,1.35,1.35,0,0,1-1.416-1.174C683.419,375.115,683.419,375.115,683.419,375.017Z",
    transform: "translate(-620.485 -363.462)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4614",
    "data-name": "Path 4614",
    d: "M689.249,373.947c0,.978.472,1.468,1.132,1.468s1.132-.587,1.132-1.468-.472-1.468-1.132-1.468C689.626,372.479,689.249,373.066,689.249,373.947Zm-.944,0c0-1.37.66-2.251,1.793-2.251a1.5,1.5,0,0,1,1.322.784h.094v-2.446h.85V376.2h-.85v-.685h-.094a1.5,1.5,0,0,1-1.322.783C689.06,376.295,688.3,375.415,688.3,373.947Z",
    transform: "translate(-620.747 -363.37)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4615",
    "data-name": "Path 4615",
    d: "M699.382,374.039q0-1.468-1.132-1.468c-.755,0-1.132.586-1.132,1.468,0,.978.377,1.565,1.132,1.565C698.91,375.6,699.382,375.016,699.382,374.039Zm-3.208,0a2,2,0,0,1,1.793-2.251,1.967,1.967,0,0,1,2.171,1.86v.391a2,2,0,0,1-1.794,2.25,1.966,1.966,0,0,1-2.17-1.859Z",
    transform: "translate(-621.16 -363.461)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4616",
    "data-name": "Path 4616",
    d: "M701.652,371.886h.849v.685h.095a1.355,1.355,0,0,1,1.227-.784,1.4,1.4,0,0,1,1.509,1.37v3.131h-.849v-2.642c0-.685-.283-1.076-.944-1.076a.985.985,0,0,0-1.038.978v2.74h-.849Z",
    transform: "translate(-621.448 -363.461)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4617",
    "data-name": "Path 4617",
    d: "M710.328,370.756v1.076h.944v.783h-.944v2.25c0,.49.189.685.567.685h.283v.685h-.472c-.944,0-1.322-.294-1.322-1.174v-2.446h-.66v-.685h.66v-1.174Z",
    transform: "translate(-621.82 -363.408)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4618",
    "data-name": "Path 4618",
    d: "M712.608,370.033h.85v2.446h.095a1.257,1.257,0,0,1,1.321-.784,1.546,1.546,0,0,1,1.51,1.37V376.2h-.85v-2.642c0-.685-.283-1.076-.944-1.076a.984.984,0,0,0-1.037.978v2.74h-.85Z",
    transform: "translate(-622.024 -363.37)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4619",
    "data-name": "Path 4619",
    d: "M718.436,373.653h2.171a1.152,1.152,0,0,0-.944-1.175h-.095A1.328,1.328,0,0,0,718.436,373.653Zm3.02,1.468a1.776,1.776,0,0,1-1.888,1.271,2.009,2.009,0,0,1-1.981-1.956v-.294a1.92,1.92,0,0,1,1.7-2.25h.282c1.227,0,1.888.88,1.888,2.25v.294h-3.02a1.119,1.119,0,0,0,1.038,1.271h.094a1.09,1.09,0,0,0,1.038-.489Z",
    transform: "translate(-622.284 -363.467)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOsAppStore);
export default __webpack_public_path__ + "static/media/iOSAppStore.ae869b1da9d0174869830b229dfe96f8.svg";
export { ForwardRef as ReactComponent };